import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./library.css";

const today = new Date().toISOString().split("T")[0];

function getStatus(issue) {
  if (issue.return_date) return "returned";
  if (issue.due_date && issue.due_date < today) return "overdue";
  return "issued";
}

export default function ReturnBook() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [issues,  setIssues]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter,  setFilter]  = useState("active"); // all | active | overdue | returned

  const loadIssues = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/library/issues/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setIssues(res.data.issues || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadIssues(); }, []);

  const markReturned = async (issueId) => {
    if (!window.confirm("Mark this book as returned?")) return;
    try {
      await API.post(
        `/school-admin/library/issues/${issueId}/return/`,
        {},
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      loadIssues();
    } catch (err) { console.error(err); alert("Failed to mark returned"); }
  };

  const active   = issues.filter(i => !i.return_date);
  const overdue  = issues.filter(i => getStatus(i) === "overdue");

  const filtered = filter === "all"      ? issues
                 : filter === "active"   ? issues.filter(i => !i.return_date)
                 : filter === "overdue"  ? issues.filter(i => getStatus(i) === "overdue")
                 : issues.filter(i => i.return_date);

  return (
    <div className="lb-page">

      {/* ══ HERO ══ */}
      <div className="lb-hero">
        <div className="lb-hero-left">
          <div className="lb-hero-icon">↩</div>
          <div>
            <h2 className="lb-hero-title">Return Book</h2>
            <p className="lb-hero-sub">
              {active.length} active issue{active.length !== 1 ? "s" : ""}
              {overdue.length > 0 && <span style={{ color:"#fca5a5", marginLeft:10 }}>⚠ {overdue.length} overdue</span>}
            </p>
          </div>
        </div>
        <div className="lb-hero-right">
          <button className="lb-btn-back" onClick={() => navigate("/school-admin/library")}>← Dashboard</button>
        </div>
      </div>

      {/* ══ FILTER ══ */}
      <div className="lb-filter">
        <span className="lb-filter-label">Show</span>
        {["active", "overdue", "returned", "all"].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: "6px 16px",
              borderRadius: "20px",
              border: "none",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: 700,
              textTransform: "capitalize",
              background: filter === f ? "#1e40af" : "#e2e8f0",
              color:      filter === f ? "#fff"    : "#475569",
              transition: "all .2s",
            }}
          >
            {f}
          </button>
        ))}
      </div>

      {/* ══ TABLE ══ */}
      <div className="lb-card">
        {loading ? (
          <div className="lb-empty">
            <div className="lb-empty-icon">⏳</div>
            <strong>Loading issues…</strong>
          </div>
        ) : filtered.length === 0 ? (
          <div className="lb-empty">
            <div className="lb-empty-icon">📭</div>
            <strong>No records found</strong>
            <p>Try a different filter</p>
          </div>
        ) : (
          <table className="lb-table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Book</th>
                <th>Copy</th>
                <th>Issue Date</th>
                <th>Due Date</th>
                <th>Status</th>
                <th>Fine</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(i => {
                const status = getStatus(i);
                return (
                  <tr key={i.id}>
                    <td><strong>{i.student_name}</strong></td>
                    <td>{i.book_title}</td>
                    <td style={{ fontFamily:"monospace", fontWeight:700 }}>{i.copy_number}</td>
                    <td>{i.issue_date}</td>
                    <td style={{ color: status === "overdue" ? "#ef4444" : "inherit" }}>{i.due_date}</td>
                    <td>
                      <span className={`lb-pill ${status}`}>
                        {status === "returned" ? "✓ Returned"
                         : status === "overdue" ? "⚠ Overdue"
                         : "📤 Issued"}
                      </span>
                    </td>
                    <td>
                      {i.fine_amount > 0
                        ? <span style={{ color:"#ef4444", fontWeight:700 }}>₹{i.fine_amount}</span>
                        : <span style={{ color:"#94a3b8" }}>—</span>}
                    </td>
                    <td>
                      {!i.return_date && (
                        <button className="lb-btn-return" onClick={() => markReturned(i.id)}>
                          ↩ Return
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

    </div>
  );
}
